module.exports = __webpack_public_path__ + "img/EOTP-logo.ae583565.svg";